import { WebHttpRequestOptions } from '@am92/web-http'

import {
  fetchSubscriptionsServiceName,
  fetchSubscriptionsTraceActions
} from '../Actions'

import serviceActionCreatorWithTokenRotation from '~/src/Redux/serviceActionCreatorWithTokenRotation'

import { asHttp } from '~/src/Configurations/WebHttp'

async function fetchSubscriptions() {
  const options: WebHttpRequestOptions = {
    url: '/subscriptions',
    method: 'GET'
  }

  const response = await asHttp.request(options)
  const { data: body } = response
  const { data } = body
  return data
}

const fetchSubscriptionsService = serviceActionCreatorWithTokenRotation(
  fetchSubscriptionsTraceActions,
  fetchSubscriptions
)

export default fetchSubscriptionsService
export { fetchSubscriptionsServiceName }
